import { afterNextRender, inject, Injectable, signal } from '@angular/core';

import { AnalyticsService } from './analytics.service';

const APPLE_PLATFORM = /mac|iphone|ipad|ipod/i;

export const shortcutHintForPlatform = (platform: string): string => (APPLE_PLATFORM.test(platform) ? '⌘K' : 'Ctrl K');

@Injectable({ providedIn: 'root' })
export class SearchService {
  readonly isOpen = signal(false);
  readonly shortcutHint = signal('Ctrl K');

  private analytics = inject(AnalyticsService);

  constructor() {
    afterNextRender(() => {
      this.shortcutHint.set(shortcutHintForPlatform(navigator.platform));
    });
  }

  close(): void {
    this.isOpen.set(false);
  }

  open(): void {
    this.isOpen.set(true);
    this.analytics.trackEvent('search_open');
  }

  toggle(): void {
    this.isOpen.update((open) => !open);

    if (this.isOpen()) this.analytics.trackEvent('search_open');
  }
}
